import React from "react";
import { Phone, Mail, MapPin, Facebook, Linkedin, Instagram, Twitter } from "lucide-react";
import { company, navLinks } from "../mock";

export default function Footer() {
  return (
    <footer className="pt-16 pb-8 relative" style={{ background: "#030524", color: "rgba(255,255,255,0.85)" }}>
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="inline-flex items-center">
            <img src="/assets/tcl-logo-white.png" alt="Top Choice Lending" className="h-16 w-auto object-contain" />
          </div>
          <p className="mt-5 text-white/60 max-w-md leading-relaxed">
            Licensed mortgage company serving Texas, Louisiana and Florida. From first-time buyers to seasoned investors,
            we shop the best rates from a network of trusted lenders.
          </p>
          <div className="flex items-center gap-3 mt-6">
            {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-full flex items-center justify-center border border-white/15 hover:border-[color:var(--gold-500)] hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.7)" }}>
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.28em] font-semibold mb-4" style={{ color: "#8DC63F" }}>Explore</div>
          <ul className="space-y-3">
            {navLinks.map(l => (
              <li key={l.href}>
                <a href={l.href} className="text-white/70 hover:text-white text-sm transition-colors">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.28em] font-semibold mb-4" style={{ color: "#8DC63F" }}>Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone size={14} className="mt-1 flex-shrink-0" style={{ color: "#8DC63F" }} /><a href={`tel:${company.phoneRaw}`} className="text-white/70 hover:text-white">{company.phone}</a></li>
            <li className="flex items-start gap-2"><Mail size={14} className="mt-1 flex-shrink-0" style={{ color: "#8DC63F" }} /><a href={`mailto:${company.email}`} className="text-white/70 hover:text-white break-all">{company.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 flex-shrink-0" style={{ color: "#8DC63F" }} /><span className="text-white/70">{company.address.line1}<br />{company.address.city}, {company.address.state} {company.address.zip}</span></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-xs text-white/50">© {new Date().getFullYear()} Top Choice Lending. All rights reserved.</div>
        <div className="text-xs text-white/40 max-w-2xl text-center md:text-right">
          Licensed in TX, LA, FL. Equal Housing Lender. This is not a commitment to lend. Rates and programs subject to change without notice.
        </div>
      </div>
    </footer>
  );
}
